module.exports = __webpack_public_path__ + "static/media/dentalcoop.2be06406.png";